import { useEffect, useState } from 'react';
export function useDebouncedValue<T>(value: T, delay = 180) { const [result, setResult] = useState(value); useEffect(() => { const timer = window.setTimeout(() => setResult(value), delay); return () => window.clearTimeout(timer); }, [value, delay]); return result; }
